import React from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { DRAWER_MODE, SideDrawer } from 'components';
import { FORM_MODES } from 'modules/campaigns/config';
import { lazyCustom } from 'modules/taboola-common-frontend-modules/lazy-loading/lazyCustom';
import { resolveLazyComponent } from 'modules/taboola-common-frontend-modules/lazy-loading/resolveLazyComponent';
import { withSuspense } from 'modules/taboola-common-frontend-modules/lazy-loading/withSuspense';
import { LayerRoute } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/components/LayerRoute/LayerRoute';
import { useMultiLayerDrawerEnabled } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { LANDING_PAGE_EDITOR_ROUTE_PATH, PATH_TO_ENTITY_MAP } from '../../config';

const LandingPageEditorLazy = lazyCustom(() =>
    import('../../pages/LandingPageEditor').then(resolveLazyComponent('LandingPageEditor'))
);
const LandingPageEditor = withSuspense(LandingPageEditorLazy);

export const EditDrawer = ({ onCancel }) => {
    const { params: { mode, entity: entityParam } = {} } = useRouteMatch(LANDING_PAGE_EDITOR_ROUTE_PATH) || {};
    const entity = PATH_TO_ENTITY_MAP[entityParam];
    const isOpen = entity && mode && mode !== FORM_MODES.CREATE;
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    if (isMultiLayerDrawerEnabled) {
        return null;
    }

    return (
        <SideDrawer openDrawer={isOpen} onClose={onCancel} drawerMode={DRAWER_MODE.LARGE}>
            {close => (
                <Switch>
                    <LayerRoute
                        exact
                        path={LANDING_PAGE_EDITOR_ROUTE_PATH}
                        render={props => <LandingPageEditor {...props} onCancel={close} />}
                    />
                </Switch>
            )}
        </SideDrawer>
    );
};
